// extracted by mini-css-extract-plugin
export default {"trash":"DailyRoutine_trash__rl-lR","table":"DailyRoutine_table__iOcbN","modal":"DailyRoutine_modal__eVjxb","buttons":"DailyRoutine_buttons__A0h3i","copy":"DailyRoutine_copy__fxGH1"};